import api from "./index";
import { ENDPOINTS } from "./endpoints";

export const initiateMpesaPayment = (data) => {
    return api.post(ENDPOINTS.PAYMENTS.INITIATE_MPESA, data);
};

export const getMpesaPaymentStatus = (orderId) => {
    return api.get(ENDPOINTS.PAYMENTS.MPESA_STATUS(orderId));
};
